<template>
  <div class="container">
    <header class="header">
      <div class="box">
        <div class="logo"><img src="./images/logo.png" class="img1" alt=""><img src="./images/slogan.png" class="img2" alt=""></div>
        <div class="login" @click="showQrcode('login')"><img src="./images/avatar.png" alt=""></div>
      </div>
    </header>
    <div class="content">
      <div class="left">
        <Player :currentVid="Number(videoVid)" ref="player" @onEnd="onVideoEnd"/>
        <div class="video-detail">
          <h1 class="title"><span>{{planDetail.title}}</span></h1>
          <div class="plan" v-if="query.type == 'plan'">
            <div class="tag"><span>学习计划</span></div>
            <span>{{planDetail.name}}</span>
          </div>
          <div class="info" v-if="query.type == 'plan'">
            <span>{{planDetail.serialOver?"共":"更新至"}}{{planDetail.planItemInfoDTOList.length}}课时 · {{planDetail.createTime.slice(0, 10)}} · {{planDetail.useNum}}个同学在学</span>
          </div>
          <p class="desc" v-if="planDetail.brief"><span>内容简介：{{planDetail.brief}}</span></p>
        </div>
      </div>
      <div class="right">
        <UserCard :detail="teacherDetail" :onClick="() => showQrcode('class')"/>
        <div class="qrcode">
          <div class="qrcode-img"><qrcode-vue :value="`https://klk.mgtv.com/#/parent/recommend?cxid=${channel.id}`" :size="96" /></div>
          <div class="text">
            <p>手机扫码进入快乐看<br/>免费看更多精彩内容</p>
            <a class="btn" @click="showQrcode('guide')">立即扫码进入 <img src="./images/arrow.png" alt=""></a>
          </div>
        </div>
        <Related
          v-show="query.type === 'video' && planDetail.recommendVideoList.length !== 0"
          title="相似视频"
          :list="planDetail.recommendVideoList.slice(0,4)"
          :currentVid="Number(videoVid)"
          :onChange="onChange"
          @more="() => showQrcode('related')"
        />
        <Related
          v-show="planDetail.planItemInfoDTOList.length !== 0"
          :title="query.type === 'video'?'相关课程':'课程列表'"
          :type="query.type"
          :list="planDetail.planItemInfoDTOList.slice(0,4)"
          :currentVid="Number(videoVid)"
          :onChange="onChange"
          @more="() => showQrcode('related')"
        />
      </div>
    </div>
    <div class="footer">
      <div class="cont">
        <div class="wrap">
          <p>Copyright 2006-2021 mgtv.com Corporation,All Rights Reserved</p>
          <p>湖南快乐阳光互动娱乐传媒有限公司 版权所有</p>
          <p>湘网文[2018]6786-055号信息网络传播视听节目许可证号:1805107</p>
          <p>互联网新闻信息服务许可证号:43120170003 <a href="https://beian.miit.gov.cn/">湘B2-20090004</a><a href="https://i5.hitv.com/s1/2017/static/hlwcbxkz.jpg">互联网出版许可证:新出网证(湘)字08号</a></p>
          <div class="qrcode-footer">
            <qrcode-vue :value="`https://klk.mgtv.com/#/parent/recommend?cxid=${channel.id}`" :size="60"/>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-layout" v-show="showTips">
      <div class="mask"></div>
      <div class="dialog">
        <div><qrcode-vue :value="channel.url"/></div>
        <p>微信/芒果TV扫一扫，发现更多精彩</p>
        <span class="close" @click="closeQrcode()"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Player from '@/components/player.vue'
import UserCard from '@/components/usercard.vue'
import Related from '@/components/related.vue'
import QrcodeVue from 'qrcode.vue'
import parseURL from '@/utils/parseURL'
import axios from '@/utils/request'

function randomString (e) {
  e = e || 32
  // eslint-disable-next-line one-var
  let t = 'abcdefghijklmnopqrstuvwxyz2345678',
    a = t.length,
    n = ''
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
  return n
}

export default {
  name: 'video-play',
  components: {
    Player,
    UserCard,
    Related,
    QrcodeVue
  },
  data () {
    return {
      query: parseURL(window.location.hash.slice(7)).params,
      channel: {
        id: parseURL(window.location.hash.slice(7)).params.type === 'video' ? '2fvxf8uus' : '1s6lhj7va',
        url: ``
      },
      videoVid: 0,
      planDetail: {
        planItemInfoDTOList: [],
        brief: '',
        title: '',
        categoryName: '',
        createTime: '',
        useNum: 0,
        name: '',
        authorName: '',
        currentVid: 0,
        recommendVideoList: [],
        serialOver: false // 是否完结
      },
      teacherDetail: {
        avatar: '',
        nickname: '',
        studentNum: 0,
        uuid: ''
      },
      showTips: false
    }
  },
  methods: {
    getData: async function () {
      if (this.query.type === 'plan') {
        /**
         * 不是的，/studyPlan/getStudyPlanItemsById 从这个接口中取videoBaseDTO ，classHour，planItemInfoDTOList。
         * 这三个字段，剩下的从/studyPlan/getStudyPlanBaseInfoById中取
         */
        const result1 = await axios.get(`https://gw.bz.mgtv.com/klk/studyPlan/getStudyPlanItemsById?id=${this.query.id}&type=1`);
        const result2 = await axios.get(`https://gw.bz.mgtv.com/klk/studyPlan/getStudyPlanBaseInfoById?id=${this.query.id}&type=1`);
        // const teacherData = result2.teacherDTO
        // this.teacherDetail.avatar = teacherData.avatar
        // this.teacherDetail.nickname = teacherData.nickname
        // this.teacherDetail.studentNum = teacherData.studentNum
        axios.get(`https://gw.bz.mgtv.com/klk/teacher/info?teacherUuid=${result2.data.teacherUuid}`).then((myJson) => {
            const teacherData = myJson.data
            this.teacherDetail.avatar = teacherData.avatar
            this.teacherDetail.nickname = teacherData.nickname
            this.teacherDetail.studentNum = teacherData.studentNum
        });
        // axios.get(`https://gw.bz.mgtv.com/klk/studyPlan/getDetailById?id=${this.query.id}&type=1`).then(res => {
        //   const planData = res.data
        //   this.planDetail.planItemInfoDTOList = planData.planItemInfoDTOList
        //   this.$set(this.planDetail, 'currentVid', this.planDetail.planItemInfoDTOList[0].videoVid)
        //   this.videoVid = this.planDetail.planItemInfoDTOList[0].videoVid
        //   this.planDetail.createTime = planData.createTime
        //   this.planDetail.useNum = planData.useNum
        //   this.planDetail.name = planData.name
        //   this.planDetail.serialOver = planData.serialOver
        //   this.teacherDetail.uuid = planData.teacherUuid
        //   this.getVideoDetail(this.planDetail.planItemInfoDTOList[0].videoVid)
        //   this.setTitle(planData.name)
        // })
        const planData = result2.data
        const planData2 = result1.data;
        this.planDetail.planItemInfoDTOList = planData2.planItemInfoDTOList
        this.$set(this.planDetail, 'currentVid', this.planDetail.planItemInfoDTOList[0].videoVid)
        this.videoVid = this.planDetail.planItemInfoDTOList[0].videoVid
        this.planDetail.createTime = planData.createTime
        this.planDetail.useNum = planData.useNum
        this.planDetail.name = planData.name
        this.planDetail.serialOver = planData.serialOver
        this.teacherDetail.uuid = planData.teacherUuid
        this.getVideoDetail(this.planDetail.planItemInfoDTOList[0].videoVid)
        this.setTitle(planData.name)
        this.$refs.player.$forceUpdate()
      } else if (this.query.type === 'video') {
        // https://gw.bz.mgtv.com/klk/video/recommend?videoVid=10018603 推荐视频接口
        // https://gw.bz.mgtv.com/klk/studyPlan/getStudyPlanListByVideoVid?videoVid=10018603 推荐计划接口
        this.$set(this.planDetail, 'currentVid', this.query.id)
        this.videoVid = this.query.id
        this.$refs.player.$forceUpdate()
        axios.get(`https://gw.bz.mgtv.com/klk/video/detail?videoVid=${this.query.id}`).then((myJson) => {
          const videoData = myJson.data
          this.planDetail.brief = videoData.brief
          this.planDetail.categoryName = videoData.categoryName
          this.planDetail.title = videoData.title
          this.teacherDetail.uuid = videoData.userUuid
          this.setTitle(videoData.title)
          axios.get(`https://gw.bz.mgtv.com/klk/teacher/info?teacherUuid=${videoData.userUuid}`).then((myJson) => {
            const teacherData = myJson.data
            this.teacherDetail.avatar = teacherData.avatar
            this.teacherDetail.nickname = teacherData.nickname
            this.teacherDetail.studentNum = teacherData.studentNum
          })
          // 获取相似视频
          axios.get(`https://gw.bz.mgtv.com/klk/video/recommend?videoVid=${this.query.id}&did=${randomString(32)}`).then((myJson) => {
            this.planDetail.recommendVideoList = myJson.data
          })
          axios.get(`https://gw.bz.mgtv.com/klk/studyPlan/getStudyPlanListByVideoVid?videoVid=${this.query.id}&?did=${randomString(32)}&page=1&pageSize=10`).then((myJson) => {
            this.planDetail.planItemInfoDTOList = myJson.data.list
          })
        })
      }
    },
    showQrcode: function (val) {
      const recommend = ['login', 'guide', 'related'] // 重定向到推荐页
      const videoDetail = ['class', 'detail'] // 重定向到班级列表页面
      if (recommend.indexOf(val) !== -1) {
        this.channel.url = `https://klk.mgtv.com/#/parent/recommend?cxid=${this.channel.id}`
      }
      if (videoDetail.indexOf(val) !== -1) {
        this.channel.url = `https://klk.mgtv.com/#/class/${this.teacherDetail.uuid}?cxid=${this.channel.id}`
      }
      this.showTips = true
    },
    closeQrcode: function () {
      this.showTips = false
    },
    setTitle: function (val) {
      document.title = val
    },
    getVideoDetail: function (id) {
      axios.get(`https://gw.bz.mgtv.com/klk/video/detail?videoVid=${id}`).then((myJson) => {
        const videoData = myJson.data
        this.planDetail.brief = videoData.brief
        this.planDetail.categoryName = videoData.categoryName
        this.planDetail.title = videoData.title
      })
    },
    onChange: function (id, type) {
      // 如果第二个参数type的值是video，那么就是在视频详情页点的
      if (type === 'video') {
        window.location.href = window.location.origin + window.location.pathname + `#/video?type=plan&id=${id}&cxid=${this.channel.id}`
        window.location.reload()
      } else {
        if (this.query.type === 'video') {
          window.location.href = window.location.origin + window.location.pathname + `#/video?type=video&id=${id}&cxid=${this.channel.id}`
          window.location.reload()
        } else {
          this.$set(this.planDetail, 'currentVid', id)
          this.videoVid = id
          this.$refs.player.$forceUpdate()
          this.getVideoDetail(id)
        }
      }
    },
    onVideoEnd: function () {
      // 仅在计划详情页面判断
      if (this.query.type === 'plan') {
        let idx = 0
        this.planDetail.planItemInfoDTOList.forEach((item, index) => {
          if (this.videoVid === item.videoVid) {
            idx = index
          }
        })
        if (idx !== this.planDetail.planItemInfoDTOList.length - 1 && idx < 3) {
          const id = this.planDetail.planItemInfoDTOList[idx + 1].videoVid
          this.$set(this.planDetail, 'currentVid', id)
          this.videoVid = id
          this.$refs.player.$forceUpdate()
          this.getVideoDetail(id)
        }
      }
    }
  },
  mounted () {
    this.getData()
    document.body.setAttribute('mg-stat-page', this.query.type === 'video' ? 'klk_playDetail' : 'klk_planDetail')
    const lob = {}
    if (this.query.type === 'video') {
      lob.vid = this.query.id
    } else {
      lob.planid = this.query.id
    }
    window.MgStat.send('pv', lob, {src: 'klk'}) // 手动发送PV
  }
}
</script>

<style scoped lang="less">
.container {
  padding-top: 60px;
  width: auto!important;
}
.header {
  width: 100%;
  height: 80px;
  line-height: 80px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  background: #fff;
}
.box {
  margin: 0 auto;
  padding: 0 50px;
&::after {
   content: "";
   clear: both;
   height: 0;
 }
}
.logo {
  float: left;
.img1 {
  width: 44px;
  height: 44px;
  margin-top: 18px;
  margin-right: 15px;
}
.img2 {
  width: 205px;
  height: 31px;
  margin-bottom: 6px;
}
}
.login {
  float: right;
  width: 44px;
  height: 44px;
  margin-top: 18px;
  cursor: pointer;
  position: relative;
&::after {
   display: block;
   content: "未登录";
   background: #0291F1;
   color: #fff;
   width: 44px;
   height: 15px;
   border-radius: 10px 0 10px 0;
   position: absolute;
   top: 0;
   left:30px;
   font-size: 12px;
   line-height: 15px;
   text-align: center;
 }
img {
  width: 100%;
}
}
.content {
  width: 83.3333%;
  min-width: 988px;
  margin: 50px auto 0;
  position: relative;
  white-space: nowrap;
&::after {
   content: "";
   display: block;
   clear: both;
   height: 0;
 }
}
.left {
  width: calc(100% - 380px);
  display: inline-block;
  position: relative;
  white-space: normal;
}
.right {
  width: 22.5%;
  min-width: 360px;
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
  white-space: normal;
}
.qrcode {
  box-sizing: border-box;
  overflow: hidden;
  width: 360px;
  height: 144px;
  background: rgba(216,216,216,.26);
  padding: 24px 20px;
  margin: 20px 0 10px 0;
}
.qrcode .text {
  float: left;
  width: 205px;
  color: #5D5E5F;
}
.qrcode .text p {
  font-size: 15px;
  text-align: center;
  margin-bottom: 18px;
  margin-top: 6px;
}
.qrcode .btn {
  display: block;
  width: 205px;
  height: 32px;
  background: #FF4D54;
  border-radius: 8px;
  opacity: 0.69;
  line-height: 32px;
  text-align: center;
  color: #fff;
  cursor: pointer;
img {
  width: 14px;
  height: 14px;
  vertical-align: -2px;
}
}
.qrcode-img {
  float: left;
  width: 96px;
  height: 96px;
  margin-right: 19px;
img {
  width: 96px;
}
}
.footer {
  height: 150px;
  background: #f4f4f4;
  margin-top: 50px;
//position: fixed;
//width: 100%;
//bottom: 0;
//left: 0;
//z-index: 6;
.cont {
  width: 1200px;
  margin: 0 auto;
}
a {
  text-decoration: none;
  color: inherit;
&:hover {
   text-decoration: underline;
 }
}
}
.footer .wrap {
  width: 1200px;
  margin: 0 auto;
  padding-top: 30px;
  text-align: center;
  position: relative;
}
.footer p {
  margin: 0;
  line-height: 1.8em;
  font-size: 12px;
}
.footer .qrcode-footer {
  position: absolute;
  top: 20px;
  left: 848px;
img {
  width: 96px;
  margin-top: 20px;
}
}
.video-detail {
.title {
  font-size: 30px;
  color: #1e1e1e;
  margin-top: 50px;
}
.plan {
  margin-bottom: 20px;
span {
  color: #27282A;
  font-size: 14px;
  opacity: 0.4;
}
}
.tag {
  background: #26D6AF;
  color: #fff;
  padding: 2px 10px;
  display: inline-block;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 10px;
span {
  color: #fff;
  opacity: 1;
}
}
.info {
  margin-top: 10px;
  color: #999;
  font-size: 12px;
}
.desc {
  color: #1e1e1e;
  font-size: 14px;
}
}
.dialog-layout {
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 11;
.mask {
  width: 100%;
  height: 100%;
  background: rgba(13, 13, 13, 0.3);
  position: fixed;
  left: 0;
  top: 0;
}
}
.dialog {
  width: 270px;
  height: 145px;
  padding: 20px;
  background: #FFFFFF;
  box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.09);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 10;
  text-align: center;
p {
  margin: 20px 0 0 0;
}
img {
  width: 80px;
  margin-top: 10px;
}
.close {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  background: url("./images/close.png")no-repeat;
  background-size: 100% 100%;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/video-play.vue